import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';

import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {MatIcon} from "@angular/material/icon";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
  selector: 'app-w2w-sw-com-cooling-performance-input',
  imports: [MatIcon, ReactiveFormsModule, FormsModule],
  templateUrl: './w2w-sw-com-cooling-performance-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './w2w-sw-com-cooling-performance-input.component.css'
})
export class W2wSwComCoolingPerformanceInputComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  sourceEftSelection!: GuruEntity;
  loadEftSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.COOLING_PERFORMANCE_INPUTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.sourceEftSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCEWT');
    this.loadEftSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCLEWT');
  }

  textSelectionChanged(entity: GuruEntity): void {
    this.selectionChanged(entity, entity.Value);
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
